import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { createMIPPersonalCustomDetails } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { CustomDetailEnum, CustomDetailDataTypeEnum } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

type CreateCustomDetailParams = {
	name: string;
	instruction: string;
	isChecked: boolean;
	type: CustomDetailEnum;
	dataType: CustomDetailDataTypeEnum;
	triggerInvestorReevaluate?: boolean;
};

export const useCreateCustomDetail = (successMessage?: string) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: CreateCustomDetailParams) => {
			return createMIPPersonalCustomDetails(params);
		},
		onSuccess: () => {
			showToastV2({
				title: successMessage,
			});
			return queryClient.invalidateQueries({ queryKey: [API_PATHS.MIP_CUSTOM_DETAIL_GET] });
		},
	});
};
